import React, { useCallback, useEffect, useRef, useState } from "react";
import "./AuditRows.css";
import {
  extractFileName,
  extractUserName,
  capitalizeFirstLetter,
} from "../../utils/util";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import AuditRowCard from "./AuditRowCard";
import DropdownFilter from "./DropdownFilter";
import {
  getAuditRows,
  getFilteredAuditData,
  getfilteroptionsdata,
  getUsers,
  lastAuditdata,
  uploadeByuser,
  codedBynameUser,
  getShortDescriptions,
  getReferenceIds
} from "../../api/Service";

import { MdOpenInNew } from "react-icons/md";
import { debounce, set } from "lodash";
import { statusTypes } from "../filters/config";
import { Spinner } from "../../common/Helper";
import { IoFilter } from "react-icons/io5";
import { SlNote } from "react-icons/sl";
import { SlBookOpen } from "react-icons/sl";
import { use } from "react";
import { useChatContext } from "../../../../../context";
export const getColor = (status) => {
  //console.log(status, "statuscolor:::");
  const red = [
    "Flagged for Review",
    "Reviewed,no change",
    "Reviewed,query required",
  ]; // #F8698521;
  const blue = [
    "Reviewed,reclaimed",
    "Reviewed,rebilled",
    "Reviewed,query required",
  ]; // #00395B
  const gray = ["Reviewed,query sent", "Reviewed,recoded"]; // #344054;
  const passed = "passed"; //#E4F5FF
  const failed = "Failed"; //#feecef;
  if (passed === status) {
    return "passed";
  }
  if (failed === status) {
    return "failed";
  }

  if (red.includes(status)) return "red";
  if (blue.includes(status)) return "blue";
  if (gray.includes(status)) return "gray";
};


function AuditRows({
  setAuditRows,
  auditRows,
  selectedIndex,
  hasMore,
  loadMore,
  isRowsLoading,
  flagauditRows,
  auditDetails,
  seteditFlageData,
  getAuditDetailsById,
  setSelectedIndex,
  setIsRowClicked,
  setPriorityVal5,
  selectedEpisodeRows,
  setSelectedEpisodeRows,
  isAllEpisodesSelected,
  setIsAllEpisodesSelected,
  appliedFilters,
  setAppliedFilters,
  getAuditRowsByFilter,
  selectedColumns,
  handleRowClick,
  isAssigned,
  setIsAssigned,
  unassined_page,
  shouldShowColumn,
  
}) {
  const { webWorkFlow } = useChatContext();
  const { setIsDateFilterActive, setDateFilter } = webWorkFlow;
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const superUserReadOnly = permissions?.super_user_readonly || false;
  const superUser = permissions?.super_user || false;
  const admin = permissions?.admin || false;
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [codedByOptions, setCodedByOptions] = useState([]);
  const [descriptionOptions,setDescriptionOptions] = useState([]);
  const [referenceIdOptions,setReferenceIdOptions] = useState([]);
  const [lastAuditedDateoptions, setLastAuditedDateOptions] = useState([]);
  const [uplodedData, setUploadeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getAllAssineByUsers, setGetAllAssineByUsers] = useState([]);
  const [getAllAssineToUsers, setGetAllAssineToUsers] = useState([]);
  const [assgineFilterByCurrentPage, setAssgineFilterByCurrentPage] =
    useState(1);
  const [assgineFilterToCurrentPage, setAssgineFilterToCurrentPage] =
    useState(1);
  const [lastAuditedDateCurrentPage, setLastAuditedDateCurrentPage] =
    useState(1);
  const [uploadeByUserCurrentPage, setUploadeByUserCurrentPage] = useState(1);
  const [codedByCurrenPage, setCodedByCurrentPage] = useState(1);
  const [descriptionCurrentPage,setDescriptionCurrentPage] = useState(1);
  const [referenceIdCurrentPage,setReferenceIdCurrentPage] = useState(1);
  const [hasMoreAssgineByUsers, setHasMoreAssgineByUsers] = useState(true);
  const [hasMoreAssgineToUsers, setHasMoreAssgineToUsers] = useState(true);
  const [hasMoreCodedBy, setHasMoreCodedBy] = useState(true);
  const [hasMoreDescriptions,setHasMoreDescriptions] = useState(true);
  const [hasMoreReferenceIds,setHasMoreReferenceIds] = useState(true);
  const [descriptionSearchData,setDescriptionSearchData] = useState("");
  const [searchData,setSearchData] = useState("")
  const [hasMoreUploadedBy, setHasMoreUploadedBy] = useState(true);
  const [loadingMoreUsers, setLoadingMoreUsers] = useState(false);
  const [filteredStatusOption, setFilterStatusOptions] = useState(statusTypes);
  const [hasMoreLastAuditedDate, setHasMoreLastAuditedDate] = useState(true);
  const [searchErrorMessage, setSearchErrorMessage] = useState("");
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [lastCheckedId, setLastCheckedId] = useState(null);
  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const [focusedRowIndex, setFocusedRowIndex] = useState(null);
  const tableRef = useRef(null);

  const handleKeyDown = (e) => {
    if (!auditRows || auditRows.length === 0) return;

    if (e.key === "Shift") {
      setIsShiftPressed(true);
      return;
    }

    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const newIndex =
        e.key === "ArrowDown"
          ? Math.min((focusedRowIndex ?? -1) + 1, auditRows.length - 1)
          : Math.max((focusedRowIndex ?? 1) - 1, 0);

      setFocusedRowIndex(newIndex);

      if (isShiftPressed && focusedRowIndex !== null) {
        // Shift + Arrow key selection
        const rowId = auditRows[newIndex].hcp_line_id;
        const isSelected = selectedEpisodeRows.includes(rowId);

        setSelectedEpisodeRows((prev) =>
          isSelected ? prev.filter((id) => id !== rowId) : [...prev, rowId]
        );
      }

      // Scroll into view
      setTimeout(() => {
        const rowElement = tableRef.current?.querySelector(
          `tr[data-row-index="${newIndex}"]`
        );
        rowElement?.scrollIntoView({ block: "nearest" });
      }, 0);
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === "Shift") {
      setIsShiftPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [auditRows, focusedRowIndex, isShiftPressed, selectedEpisodeRows]);

  useEffect(() => {
    const hasDateFilter = !!appliedFilters.hcp_line_updated_at;
    setIsDateFilterActive(hasDateFilter);
    setDateFilter(hasDateFilter ? appliedFilters.hcp_line_updated_at[0] : null);
  }, [appliedFilters.hcp_line_updated_at]);

  const getMoreAssigneByUsers = async (page, load_more) => {
    try {
      setLoadingMoreUsers(true);
      const response = await getUsers(searchData, page);
      const { users } = response.data;

      const mergedUsers = load_more
        ? [
            ...new Map(
              [...getAllAssineByUsers, ...users].map((item) => [
                item.user_id,
                item,
              ])
            ).values(),
          ]
        : users;

      // If we have existing filters, ensure they're included
      if (appliedFilters.assigned_by?.length) {
        const filteredUsers = users.filter((user) =>
          appliedFilters.assigned_by.includes(user.user_id)
        );
        setGetAllAssineByUsers([
          ...new Set([...mergedUsers, ...filteredUsers]),
        ]);
      } else {
        setGetAllAssineByUsers(mergedUsers);
      }

      setHasMoreAssgineByUsers(users.length > 0);
      setAssgineFilterByCurrentPage(page + 1);
    } catch (error) {
      console.error("Error fetching users:", error);
      setHasMoreAssgineByUsers(false);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const getMoreAssigneToUsers = async (page, load_more) => {
    try {
      setLoadingMoreUsers(true);
      const response = await getUsers(searchData, page);
      const { users } = response.data;

      const mergedUsers = load_more
        ? [
            ...new Map(
              [...getAllAssineToUsers, ...users].map((item) => [
                item.user_id,
                item,
              ])
            ).values(),
          ]
        : users;

      // If we have existing filters, ensure they're included
      if (appliedFilters.assigned_to?.length) {
        const filteredUsers = users.filter((user) =>
          appliedFilters.assigned_to.includes(user.user_id)
        );
        setGetAllAssineToUsers([
          ...new Set([...mergedUsers, ...filteredUsers]),
        ]);
      } else {
        setGetAllAssineToUsers(mergedUsers);
      }

      setHasMoreAssgineToUsers(users.length > 0);
      setAssgineFilterToCurrentPage(page + 1);
    } catch (error) {
      console.error("Error fetching users:", error);
      setHasMoreAssgineToUsers(false);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const uploadeByuservalue = async (page, load_more) => {
    try {
      setLoadingMoreUsers(true);
      const response = await uploadeByuser(searchData, page);
      const { uploaded_by_user_name } = response.data.audit_rules;
      const uploadedUsers = uploaded_by_user_name.flat();
      const mergedUsers = load_more
        ? [...new Set([...uplodedData, ...uploadedUsers])]
        : uploadedUsers;

      // If we have existing filters, ensure they're included
      if (appliedFilters.uploaded_by_user_name?.length) {
        const filteredUsers = uploadedUsers.filter((user) =>
          appliedFilters.uploaded_by_user_name.includes(user)
        );
        setUploadeData([...new Set([...mergedUsers, ...filteredUsers])]);
      } else {
        setUploadeData(mergedUsers);
      }

      setHasMoreUploadedBy(uploadedUsers.length > 0);
      setUploadeByUserCurrentPage(page + 1);
    } catch (error) {
      console.error("Error fetching users:", error);
      setHasMoreUploadedBy(false);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const coderNameUserValue = async (page, load_more) => {
    try {
      setLoadingMoreUsers(true);
      const response = await codedBynameUser(searchData, page);
  

      const { coder_name } = response.data.audit_rules;
      const coders = coder_name.flat();
      const mergedUsers = load_more
        ? [...new Set([...codedByOptions, ...coders])]
        : coders;

      // If we have existing filters, ensure they're included
      if (appliedFilters.coder_name?.length) {
        const filteredCoders = coders.filter((coder) =>
          appliedFilters.coder_name.includes(coder)
        );
        setCodedByOptions([...new Set([...mergedUsers, ...filteredCoders])]);
      } else {
        setCodedByOptions(mergedUsers);
      }

      setHasMoreCodedBy(coders.length > 0);
      setCodedByCurrentPage(page + 1);
    } catch (error) {
      console.error("Error fetching coders:", error);
      setHasMoreCodedBy(false);
    } finally {
      setLoadingMoreUsers(false);
    }
  };
  const fetchShortDescription = async (page, load_more) => {
    try {
      setLoadingMoreUsers(true);
      const response = await getShortDescriptions(searchData, page);
      const {short_description} = response.data.audit_rules;
      const descriptions = short_description?.flat();
      const mergedDescriptions = load_more
        ? [...new Set([...descriptionOptions, ...descriptions])]
        : descriptions;

      // If we have existing filters, ensure they're included
      if (appliedFilters.short_description?.length) {
        const filteredDescriptions = descriptions?.filter((desc) =>
          appliedFilters.short_description?.includes(desc)
        );
         setDescriptionOptions([...new Set([...mergedDescriptions, ...filteredDescriptions])]);
       } else {
         setDescriptionOptions(mergedDescriptions);
       }

       setHasMoreDescriptions(descriptions.length > 0);
       setDescriptionCurrentPage(page + 1);
    } 
    catch (error) {
      console.error("Error fetching coders:", error);
      setHasMoreDescriptions(false);
    } finally {
      setLoadingMoreUsers(false);
    }
  }
  const fetchReferenceId = async(page, load_more)=>{
    try {
      setLoadingMoreUsers(true);
      const response = await getReferenceIds(searchData,page);
      const {audit_ref_no} = response.data.audit_rules;
      const referenceIds = audit_ref_no?.flat();
      const mergedReferenceIds = load_more
        ? [...new Set([...referenceIdOptions, ...referenceIds])]
        : referenceIds;
      // If we have existing filters, ensure they're included
      if (appliedFilters.audit_ref_no?.length) {
        const filteredReferenceIds = referenceIds.filter((id) =>
          appliedFilters.audit_ref_no.includes(id)
        );
         setReferenceIdOptions([...new Set([...mergedReferenceIds, ...filteredReferenceIds])]);
       } else {
         setReferenceIdOptions(mergedReferenceIds);
       }

       setHasMoreReferenceIds(referenceIds.length > 0);
       setReferenceIdCurrentPage(page + 1);
    } 
    catch (error) {
      console.error("Error fetching coders:", error);
      setHasMoreReferenceIds(false);
    } finally {
      setLoadingMoreUsers(false);
      // console.log(referenceIdOptions,"resu");
    }

  }
  const lastAuditdatavalue = async (page, load_more) => {
    try {
      setLoadingMoreUsers(true);
      const response = await lastAuditdata("", page);
      const { hcp_line_updated_at } = response.data.audit_rules;

      const normalizedDates = hcp_line_updated_at.flat().map((date) => {
        const dateObj = new Date(date);
        return dateObj.toISOString().split("T")[0];
      });

      const uniqueDates = [...new Set(normalizedDates)];

      const mergedDates = load_more
        ? [...new Set([...lastAuditedDateoptions, ...uniqueDates])]
        : uniqueDates;

      // If we have existing filters, ensure they're included
      if (appliedFilters.hcp_line_updated_at?.length) {
        const filteredDates = uniqueDates.filter((date) =>
          appliedFilters.hcp_line_updated_at.includes(date)
        );
        setLastAuditedDateOptions([
          ...new Set([...mergedDates, ...filteredDates]),
        ]);
      } else {
        setLastAuditedDateOptions(mergedDates);
      }

      setHasMoreLastAuditedDate(uniqueDates.length > 0);
      setLastAuditedDateCurrentPage(page + 1);
    } catch (error) {
      console.error("Error fetching dates:", error);
      setHasMoreLastAuditedDate(false);
    } finally {
      setLoadingMoreUsers(false);
    }
  };
  const toggleDropdown = (column, event) => {
   setSearchData("");
    const copyOpenDropDowns = structuredClone(openDropdowns);
    if (Object.hasOwn(copyOpenDropDowns, column)) {
      delete copyOpenDropDowns[column];
      if (column === "status") {
        setFilterStatusOptions(statusTypes);
      }
    } else {
      const positionX =
        event.clientX - event.currentTarget.offsetParent.offsetWidth;
      const positionY = event.clientY + 10;
      copyOpenDropDowns[column] = {
        isOpen: true,
        positionX,
        positionY,
      };
      const shouldReset = appliedFilters[column]?.length;
      if (column === "coder_name") {
        setCodedByCurrentPage(1);
        setIsLoading(true);
        coderNameUserValue(1, !shouldReset)
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      } else if (column === "assigned_by") {
        setAssgineFilterByCurrentPage(1);
        setIsLoading(true);
        getMoreAssigneByUsers(1, !shouldReset)
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      } else if (column === "assigned_to") {
        setIsLoading(true);
        setAssgineFilterToCurrentPage(1);
        getMoreAssigneToUsers(1, !shouldReset)
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      } else if (column === "hcp_line_updated_at") {
        setLastAuditedDateCurrentPage(1);
        setIsLoading(true);
        lastAuditdatavalue(1, !shouldReset)
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      } else if (column === "uploaded_by_user_name") {
        setUploadeByUserCurrentPage(1);
        setIsLoading(true);
        uploadeByuservalue(1, !shouldReset)
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      }
      else if(column === "short_description"){
        setDescriptionCurrentPage(1);
        setIsLoading(true);
        fetchShortDescription(1, !shouldReset)
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      }
      else if(column === "audit_ref_no"){
        setReferenceIdCurrentPage(1);
        setIsLoading(true);
        fetchReferenceId(1, !shouldReset)
        .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      }
    }
    setOpenDropdowns(copyOpenDropDowns);
  };

  const handleTempFilterChange = (column, value, checked) => {

    
    setAppliedFilters((prevFilters) => ({
      ...prevFilters,
      [column]: checked
        ? [...(prevFilters[column] || []), value]
        : (prevFilters[column] || []).filter((item) => item !== value),
    }));
  };

  const applyFilters = () => {
    getAuditRowsByFilter(appliedFilters);
  };

  let unflage = (row) => {
    //console.log("My row", row);
    seteditFlageData(row);
    //console.log("AUDITROW::::::", row);
    //console.log('clciked')
    getAuditDetailsById(row.hcp_line_id);
    const index = auditRows.findIndex(
      (data) => data.hcp_line_id === row.hcp_line_id
    );
    setSelectedIndex(index);
    setIsRowClicked(true);
    setPriorityVal5(row.priority_value === 5 ? true : false);
  };

  useEffect(() => {
    if (isAllEpisodesSelected) {
      setSelectedEpisodeRows(auditRows.map((row) => row.hcp_line_id));
    } else {
      setSelectedEpisodeRows((prev) => prev);
    }
  }, [auditRows, isAllEpisodesSelected]);

  useEffect(() => {
    setSelectedEpisodeRows(selectedEpisodeRows);
  }, [selectedEpisodeRows]);

  const selectAllAssignedToRows = (event) => {
    const sendAllIds = auditRows.map((id) => id.hcp_line_id);
    if (event && event.target.checked) {
      setSelectedEpisodeRows(sendAllIds);
      setIsAllEpisodesSelected(true);
    } else {
      setSelectedEpisodeRows([]);
      setIsAllEpisodesSelected(false);
    }
  };
  const getMoreAssigneByUsersSearch = async (searchedUser, page) => {
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");
      const response = await getUsers(searchedUser);
      const { users } = response.data;
      setGetAllAssineByUsers(users);
    } catch (error) {
      setAssgineFilterByCurrentPage(1);
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found");
      console.log(error);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const getMoreAssigneToUsersSearch = async (searchedUser) => {
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");
      const response = await getUsers(searchedUser);
      const { users } = response.data;
      setGetAllAssineToUsers(users);
    } catch (error) {
      setAssgineFilterToCurrentPage(1);
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found");
      console.log(error);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const getSearchUploadedByUser = async (searchedUser) => {
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");
      const response = await uploadeByuser(searchedUser);
      const { uploaded_by_user_name } = response.data.audit_rules;
      setUploadeData(uploaded_by_user_name.flat());
    } catch (error) {
      setUploadeByUserCurrentPage(1);
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found");
      console.log(error);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const getSearchLastAuditeDate = async (searchedUser) => {
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");

      const response = await lastAuditdata(searchedUser);
      const { hcp_line_updated_at } = response.data.audit_rules;

      const normalizedDates = hcp_line_updated_at.flat().map((date) => {
        const dateObj = new Date(date);
        return dateObj.toISOString().split("T")[0];
      });

      const uniqueDates = [...new Set(normalizedDates)];

      setLastAuditedDateOptions(uniqueDates);
    } catch (error) {
      setLastAuditedDateCurrentPage(1);
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found");
      console.log(error);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

  const getSearchCodeByUser = async (searchedUser) => {
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");
      const response = await codedBynameUser(searchedUser);
      const { coder_name } = response.data.audit_rules;
      setCodedByOptions(coder_name.flat());
    } catch (error) {
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found.");
    } finally {
      setLoadingMoreUsers(false);
    }
  };
  const getSearchDescriptions = async (desc)=>{
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");
      const response = await getShortDescriptions(desc);
      const {short_description} = response.data.audit_rules;
      setDescriptionOptions(short_description?.flat())
    } catch (error) {
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found.");
    }finally {
      setLoadingMoreUsers(false);
    }
  }
  const getSearchReferenceIds = async (id)=>{
    try {
      setLoadingMoreUsers(true);
      setSearchErrorMessage("");
      const response = await getReferenceIds(id);
      const {audit_ref_no} = response.data.audit_rules;
      setReferenceIdOptions(audit_ref_no?.flat())
    } catch (error) {
      setLoadingMoreUsers(false);
      setSearchErrorMessage("No data found.");
    }finally{
      setLoadingMoreUsers(false);
    }
  }

  const handleSearchChange = useCallback(
    debounce((column, value) => {
      if (column === "assigned_by") {
        // setSearchFilterAssgineeByUserName(value);
        setSearchData(value);
        getMoreAssigneByUsersSearch(value, assgineFilterByCurrentPage);
      } else if (column === "assigned_to") {
        // setSearchFilterAssgineeToUserName(value);
        setSearchData(value)
        getMoreAssigneToUsersSearch(value, assgineFilterToCurrentPage);
      } else if (column === "hcp_line_updated_at") {
        // setSearchFilterLastAuditedDate(value);
       
        getSearchLastAuditeDate(value, lastAuditedDateCurrentPage);
      } else if (column === "uploaded_by_user_name") {
        // setSearchFilterUploadedBy(value);
        setSearchData(value)
        getSearchUploadedByUser(value, uploadeByUserCurrentPage);
      } else if (column === "status") {
        const filterStatus = statusTypes.filter((status) =>
          status.toLowerCase().includes(value.toLowerCase())
        );
        setFilterStatusOptions(filterStatus);
      } else if (column === "coder_name") {
        setSearchData(value)
        getSearchCodeByUser(value, codedByCurrenPage);
      }
      else if (column ==="short_description"){
        setSearchData(value)
        setDescriptionSearchData(value)
        getSearchDescriptions(value, descriptionCurrentPage)
      }
      else if(column ==="audit_ref_no"){
        setSearchData(value)
        getSearchReferenceIds(value, referenceIdCurrentPage)
      }
    }, 300),
    []
  );

  useEffect(() => {
    // When filters change, ensure dropdown data includes filtered items
    const loadFilteredData = async () => {
      for (const [column, values] of Object.entries(appliedFilters)) {
        if (values?.length > 0) {
          switch (column) {
            case "assigned_by":
              await getMoreAssigneByUsers(1, false);
              break;
            case "coder_name":
              await coderNameUserValue(1, false);
              break;
            case "assigned_to":
              await getMoreAssigneToUsers(1, false);
              break;
            case "hcp_line_updated_at":
              await lastAuditdatavalue(1, false);
              break;
            case "uploaded_by_user_name":
              await uploadeByuservalue(1, false);
              break;
            default:
          }
        }
      }
    };

    loadFilteredData();
  }, [appliedFilters]);

  return (
    <>
      <InfiniteScroll
        className=" audits-main"
        hasData={hasMore}
        loadMore={() => loadMore()}
        isLoading={isRowsLoading}
      >
        <table
          id="audits-main"
          tabIndex={0}
          onKeyDown={handleKeyDown}
          className={
            isMouseDown || isShiftPressed ? "drag-selection-active" : ""
          }
          onMouseDown={() => setIsMouseDown(true)}
          onMouseUp={() => {
            setIsMouseDown(false);
            setLastCheckedId(null);
          }}
          onMouseLeave={() => setIsMouseDown(false)}
        >
          <thead style={{ position: "relative" }}>
            <tr style={{backgroundColor:"#c8cad9"}}>
              <th>
                <input
                  type="checkbox"
                  onChange={selectAllAssignedToRows}
                  checked={isAllEpisodesSelected}
                  style={{
                    height: "15px",
                    width: "15px",
                  }}
                />
              </th>
              {/* <th>View Details</th> */}
              {shouldShowColumn ("priority")&&<th>Priority</th>}
              {shouldShowColumn("file_name")&&<th className="table-filter-header">Document Name</th>}
              {shouldShowColumn("audit_ref_no")&&<th >Reference Id{!flagauditRows&&!unassined_page&&<span   onClick={(e) => toggleDropdown("audit_ref_no", e)} >
                <IoFilter className="header-filter-icon" />
                </span>}
                </th>}
              {shouldShowColumn("coded_by")&&<th>
                Coded By
                {!flagauditRows&&!unassined_page&&<span   onClick={(e) => toggleDropdown("coder_name", e)} >
                <IoFilter className="header-filter-icon" />
                </span>}
              </th>}
              {shouldShowColumn("uploaded_by_user_name")&& <th>
                Uploaded By
                {!flagauditRows&&!unassined_page&&<span  onClick={(e) => toggleDropdown("uploaded_by_user_name", e)}>
                <IoFilter className="header-filter-icon"/>
                  </span>}
              </th>}
              {shouldShowColumn("date")&&<th>Date</th>}
              {shouldShowColumn ( "assigned_by")&&<th>
                {unassined_page?"Unassigned By":"Assigned By" }
                {!flagauditRows&&!unassined_page&&<span  onClick={(e) => toggleDropdown("assigned_by", e)}>
                <IoFilter className="header-filter-icon"/>
                  </span>}
              </th>}
              {shouldShowColumn("assigned_to")&& !unassined_page&& <th>
                Assigned To
                {!flagauditRows&&!unassined_page&&
                  (admin || superUser || superUserReadOnly) && (
                    <span
                      onClick={(e) => {
                        toggleDropdown("assigned_to", e);
                      }}
                    >
                      <IoFilter className="header-filter-icon" />
                    </span>
                  )}
              </th>}
              {shouldShowColumn("audit_rule_short_description")&&<th>Description
              {!flagauditRows&&!unassined_page&&(
                  <span onClick={(e) => toggleDropdown("short_description", e)}>
                    <IoFilter className="header-filter-icon" />
                  </span>
                )}
              </th>}
              {shouldShowColumn("status")&&<th>
                Status
                {/* {!flagauditRows&&!unassined_page&&(
                  <span onClick={(e) => toggleDropdown("status", e)}>
                    <IoFilter className="header-filter-icon" />
                  </span>
                )} */}
              </th>}

              {shouldShowColumn("episode_identifier")&&<th>Episode Identifier</th>}
              {shouldShowColumn("hcp_line_updated_at")&&<th>
                Last Audited Date
                {!flagauditRows&&!unassined_page&& (
                  <span
                    onClick={(e) => toggleDropdown("hcp_line_updated_at", e)}
                  >
                    <IoFilter className="header-filter-icon" />
                  </span>
                )}
              </th>}
            </tr>
          </thead>
          <tbody>
            {auditRows &&
              auditRows.map((row, index) => (
                <AuditRowCard
                  key={index}
                  row={row}
                  handleRowClick={handleRowClick}
                  isActive={selectedIndex === index}
                  flagauditRows={flagauditRows}
                  unflage={unflage}
                  auditDetails={auditDetails}
                  selectedEpisodeRows={selectedEpisodeRows}
                  setSelectedEpisodeRows={setSelectedEpisodeRows}
                  isAllEpisodesSelected={isAllEpisodesSelected}
                  setIsAllEpisodesSelected={setIsAllEpisodesSelected}
                  unassined_page={unassined_page}
                  isMouseDown={isMouseDown}
                  lastCheckedId={lastCheckedId}
                  setLastCheckedId={setLastCheckedId}
                  isShiftPressed={isShiftPressed}
                  isFocused={focusedRowIndex === index}
                  selectedColumns={selectedColumns}
                  shouldShowColumn = {shouldShowColumn}
                />
              ))}
          </tbody>
        </table>
      </InfiniteScroll>
      {Object.entries(openDropdowns).map(
        ([column, columnInfo]) =>
          columnInfo.isOpen && (
            <DropdownFilter
              key={column}
              column={column}
              options={
                column === "coder_name"
                  ? codedByOptions
                  : column === "assigned_by"
                  ? getAllAssineByUsers
                  : column === "assigned_to"
                  ? getAllAssineToUsers
                  : column === "status"
                  ? filteredStatusOption
                  : column === "uploaded_by_user_name"
                  ? uplodedData
                  : column === "hcp_line_updated_at"
                  ? lastAuditedDateoptions
                  : column === "short_description"?
                  descriptionOptions
                  :column === "audit_ref_no"?
                  referenceIdOptions
                  : []
              }
              selectedOptions={appliedFilters[column] || []}
              onChangeHandlerCheckBox={handleTempFilterChange}
              closeDropdown={() => toggleDropdown(column)}
              stylePosition={columnInfo}
              isLoading={isLoading}
              loadingMoreUsers={loadingMoreUsers}
              loadMoreOptions={() =>
                column === "coder_name"
                  ? coderNameUserValue(codedByCurrenPage, true)
                  : column === "assigned_by"
                  ? getMoreAssigneByUsers(assgineFilterByCurrentPage, true)
                  : column === "assigned_to"
                  ? getMoreAssigneToUsers(assgineFilterToCurrentPage, true)
                  : column === "hcp_line_updated_at"
                  ? lastAuditdatavalue(lastAuditedDateCurrentPage, true)
                  : column === "uploaded_by_user_name"
                  ? uploadeByuservalue(uploadeByUserCurrentPage, true)
                  :column === "short_description"
                  ? fetchShortDescription(descriptionCurrentPage, true)
                  :column === "audit_ref_no"
                  ? fetchReferenceId(referenceIdCurrentPage, true)
                  : null
              }
              handleSearchChange={handleSearchChange}
              hasMoreAssgineByUsers={hasMoreAssgineByUsers}
              hasMoreAssgineToUsers={hasMoreAssgineToUsers}
              hasMoreUploadedBy={hasMoreUploadedBy}
              hasMoreCodedBy={hasMoreCodedBy}
              hasMoreLastAuditedDate={hasMoreLastAuditedDate}
              hasMoreDescriptions={hasMoreDescriptions}
              hasMoreReferenceIds={hasMoreReferenceIds}
              applyFilters={applyFilters}
              searchErrorMessage={searchErrorMessage}
              descriptionSearchData={descriptionSearchData}
              setDescriptionSearchData={setDescriptionSearchData}
            />
          )
      )}
    </>
  );
}


export default AuditRows;
